module.exports = __webpack_public_path__ + "static/img/downloadpopup2.88d8f909.webp";